module.exports = __webpack_public_path__ + "img/wgjzz.98cefd4a.png";